module.exports = __webpack_public_path__ + "static/media/AssassinsGarb.afcb3b2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BodyDEX/AssassinsGarb.png
// module id = 414
// module chunks = 0